export var APPCONSTANT = {
	TOKEN: "",
	CURRENCY: "",
	ENVIRONMENT: "",
	DOMAIN: "",
	DOMAIN_ID: 0,
	CUSTOM_HEADER: {},
};

export const TYPES = {
	account: "accounts",
	listing: "listings",
	event: "event",
};
